import ApiService, { HTTPMethod } from './api.core'
import { FirebaseService, FirebaseConfigKey } from '../services/FirebaseService'
import dayjs from 'dayjs'

class OperatorsApi {
  async addOperator(values) {
    let data = Object.assign({}, values, {
      first_name: values.first_name.toUpperCase(),
      last_name: values.last_name.toUpperCase(),
      identification_number: 311510085,
      license_endorsed_for_motorcycle: values.license_endorsed_for_motorcycle == 'yes',
      recent_accident: values.recent_accident == 'yes',
      own_home: values.own_home == 'yes',
      residence_insurance: values.residence_insurance == 'yes',
      active_military: values.active_military == 'yes',
      vehicle_ids: values.operates,
      date_of_birth: dayjs(values.date_of_birth).format('YYYY-MM-DD'),
      is_married: values.is_married,
      experience_years: values.experience_years,
      education_level: values.education_level,
      is_owner: values.is_owner,
    })

    return ApiService.fetch('users/me/persons', HTTPMethod.POST, data)
  }

  async updateOperator(values) {
    let data = Object.assign({}, values, {
      first_name: values.first_name.toUpperCase(),
      last_name: values.last_name.toUpperCase(),
      identification_number: 311510085,
      license_endorsed_for_motorcycle: values.license_endorsed_for_motorcycle == 'yes',
      recent_accident: values.recent_accident == 'yes',
      own_home: values.own_home == 'yes',
      residence_insurance: values.residence_insurance == 'yes',
      active_military: values.active_military == 'yes',
      vehicle_ids: values.operates,
      driver_license: values.driver_license ? values.driver_license.trim() : undefined,
      driver_license_image_url: values.driver_license_image_url ? values.driver_license_image_url.trim() : undefined,
      date_of_birth: dayjs(values.date_of_birth).format('YYYY-MM-DD'),
      is_married: values.is_married,
      experience_years: values.experience_years,
      education_level: values.education_level,
    })
    return ApiService.fetch(`users/me/persons/${values.id}`, HTTPMethod.PUT, data)
  }

  async uploadLicense(insuredPersonId, file) {
    return ApiService.uploadFile(`users/me/persons/${insuredPersonId}/upload-license`, file)
  }

  async deleteOperator(id) {
    return ApiService.fetch('users/me/persons', HTTPMethod.DELETE, {
      user_insured_person_id: id,
    })
  }
  async getMvrData(insuredPersonId) {
    return await ApiService.fetch(`users/me/persons/mvr/${insuredPersonId}`, HTTPMethod.GET)
  }

  async operatorsDetailsNext() {
    return ApiService.fetch('users/me/persons/operators_details_next', HTTPMethod.GET)
  }
}

export default new OperatorsApi()
